import Vue from 'vue';
import commonAPI from "../api/common"
import chartAPI from '../api/chart';
import common from '../../libs/common';
import i18n from '../../i18n';
import {ADD_TOAST_MESSAGE} from "vuex-toast";

const types = {
  LOADING: 'LOADING',
  LOADING_BY_KEY: "LOADING_BY_KEY",
  GET_TOTAL_STOCKS_SUCCESS: 'GET_TOTAL_STOCKS_SUCCESS',
  GET_B_INDICATOR_SUCCESS: 'GET_B_INDICATOR_SUCCESS',
  GET_CANDLE_CHART_OK: 'GET_CANDLE_CHART_OK',
  SEARCH_STOCK_OK: 'SEARCH_STOCK_OK',
  GET_SECTORS_OK: 'GET_SECTORS_OK',
  GET_INDUSTRIES_OK: 'GET_INDUSTRIES_OK',
};

const mapSector = {
  ENE: 'energy',
  HEA: 'health',
  IND: 'industry',
  AGR: 'agri',
  FIN: 'fin',
  TEC: 'tech',
  REA: 'real',
  MAT: 'material',
  TEL: 'telecom',
  CON: 'consumer',
  UTI: 'utility',
  UNK: 'unknown'
};

const initalState = {
  loading: false,
  form: {},
  noOfStocks: 0,
  bIndicator: 0,
  industries: [],
  sectors: [],
  candleChart: {
    series: [
      {
        name: 'CandleStick',
        data: []
      }],
    chartOptions: {
      chart: {
        type: 'candlestick',
        height: 290,
        toolbar: {
          show: true
        }
      },
      xaxis: {
        type: 'category',
        labels: {
          formatter: function (timestamp) {
            var formattedDate = common.formatWeekday(timestamp);
            return formattedDate;
          },
          show: false,
        },
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: false
        }
      },
      yaxis: {
        labels: {
          // show : false,
          offsetX: -5,
          formatter: function (value) {
            return "$" + value.toFixed(1);
          }
        },
        tooltip: {
          enabled: true
        }
      },
      plotOptions: {
        candlestick: {
          columnWidth: '100%',
        }
      },
      tooltip: {
        shared: true,
        intersect: false,
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          const o = w.globals.seriesCandleO[seriesIndex][dataPointIndex];
          const c = w.globals.seriesCandleC[seriesIndex][dataPointIndex];
          const h = w.globals.seriesCandleH[seriesIndex][dataPointIndex];
          const l = w.globals.seriesCandleL[seriesIndex][dataPointIndex];
          // const date = common.formatDate(w.globals.labels[dataPointIndex]);
          return `
            <div class="chart-tooltip">
              <div>${i18n.t('common.open')}: <strong>${o}</strong></div>
              <div>${i18n.t('common.highest')}: <strong>${h}</strong></div>
              <div>${i18n.t('common.lowest')}: <strong>${l}</strong></div>
              <div>${i18n.t('common.close')}: <strong>${c}</strong></div>
            </div>`;
        }
      }
    }
  },
  volumeChart: {
    series: [
      {
        name: 'Volume',
        data: []
      }],
    chartOptions: {
      chart: {
        height: 290,
        type: 'bar',
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        type: 'category',
        labels: {
          // show: false,
          formatter: function (timestamp) {
            var formattedDate = common.formatDate(timestamp);
            return formattedDate;
          },
        },
        axisBorder: {
          show: false // Hide the x-axis border line
        },
        axisTicks: {
          show: false // Hide the x-axis ticks
        }
      },
      plotOptions: {
        bar: {
          columnWidth: '61%',  // Adjust the width of the volume bars
        }
      },
      yaxis: {
        labels: {
          // show : false,
          offsetX: -5,
          formatter: function (value) {
            if (value >= 1000000) {
              return (value / 1000000) + "M";
            } else if (value >= 1000) {
              return (value / 1000) + "K";
            }
            return value.toFixed(0);
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        show: false,  // Hide the grid completely
      },
      tooltip: {
        shared: true,
        intersect: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const volume = w.globals.series[seriesIndex][dataPointIndex];
          const date = common.formatWeekday(w.globals.labels[dataPointIndex]);
          return `
            <div class="chart-tooltip">
              <div>${date}</div>
              <div>${i18n.t('common.abbr_volume')}: <strong>${volume.toLocaleString()}</strong></div>
            </div>`;
        }
      }
    }
  },
  filteredStocks: []
};

const getters = {
  form: state => state.form,
  loading: state => state.loading,
  noOfStocks: state => state.noOfStocks,
  bIndicator: state => state.bIndicator,
  candleChart: state => state.candleChart,
  volumeChart: state => state.volumeChart,
  filteredStocks: state => state.filteredStocks,
  industries: state => state.industries,
  sectors: state => state.sectors
};

const actions = {
  async getIndustries({ commit, dispatch }, sectorCode) {
    try {
      commit('LOADING_BY_KEY', { key: "industriesLoading", status: true });
      const { data } = await commonAPI(dispatch).getIndustries(sectorCode);
      commit(types.GET_INDUSTRIES_OK, data);
    } catch (e) {
      Vue.$log.error('Failed to retrieve industries', e);
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: 'Failed to retrieve industries', type: "danger" },
        { root: true }
      );
      commit('LOADING_BY_KEY', { key: "industriesLoading", status: false });
    }
  },

  async getSectors({ commit, dispatch }) {
    try {
      commit('LOADING_BY_KEY', { key: "sectorsLoading", status: true });
      const { data } = await commonAPI(dispatch).getSectors();
      commit(types.GET_SECTORS_OK, data);
    } catch (e) {
      Vue.$log.error(i18n.t('messages.sectors_get_failed'), e);
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: i18n.t('messages.sectors_get_failed'), type: "danger" },
        { root: true }
      );
      commit('LOADING_BY_KEY', { key: "sectorsLoading", status: false });
    }
  },

  async getPriceHistoryByCode({ commit, dispatch }, params) {
    try {
      commit('LOADING_BY_KEY', { key: "candleLoading", status: true });
      const { data } = await chartAPI(dispatch).getPriceHistory(params.code, params.period);
      commit(types.GET_CANDLE_CHART_OK, data);
    } catch (e) {
      Vue.$log.error('Failed to get candle chart', e);
    }
  },

  async searchStock({ commit, dispatch }, pattern) {
    try {
      const { data } = await commonAPI(dispatch).getAvailableCodes2(pattern);
      commit(types.SEARCH_STOCK_OK, data);
    } catch (e) {
      Vue.$log.error('Failed to search stock', e);
    }
  },

  async getBIndicator({ commit, dispatch }) {
    try {
      const { data } = await commonAPI(dispatch).getBIndicator();
      commit(types.GET_B_INDICATOR_SUCCESS, data);
    } catch (e) {
      Vue.$log.error('Failed to get Buffett Indicator', e);
    }
  },

  async getNoOfStocks({ commit, dispatch }) {
    try {
      const { data } = await commonAPI(dispatch).getNoOfStocks();
      commit(types.GET_TOTAL_STOCKS_SUCCESS, data);
    } catch (e) {
      Vue.$log.error('Failed to get total stocks', e);
    }
  },
};

const mutations = {
  [types.LOADING](state, loading) {
    Vue.set(state, 'loading', loading);
  },

  [types.LOADING_BY_KEY](state, data) {
    Vue.set(state.form, data.key, data.status);
  },

  [types.SEARCH_STOCK_OK](state, data) {
    Vue.set(state, 'filteredStocks', data.items);
  },

  [types.GET_TOTAL_STOCKS_SUCCESS](state, data) {
    Vue.set(state, 'noOfStocks', data);
  },

  [types.GET_B_INDICATOR_SUCCESS](state, data) {
    Vue.set(state, 'bIndicator', data);
  },

  [types.GET_CANDLE_CHART_OK](state, data) {
    let values = [];
    let values1 = [];
    data.items.map(item => {
      values.push({ 'x': item.x, 'y': [_.round(item.y[0] / 1000, 2), _.round(item.y[1] / 1000, 2), _.round(item.y[2] / 1000, 2), _.round(item.y[3] / 1000, 2)] });
      values1.push({ 'x': item.x, 'y': item.volume })
    });
    values = values.slice().reverse();
    values1 = values1.slice().reverse();
    Vue.set(state.candleChart.series[0], 'data', values);
    Vue.set(state.volumeChart.series[0], 'data', values1);
    Vue.set(state.form, 'candleLoading', false);
  },

  [types.GET_SECTORS_OK](state, data) {
    const options = data.map(item => ({
      value: item.code,
      text: i18n.t(`sector_types.${mapSector[item.code]}`)
    }));
    Vue.set(state, 'sectors', options);
    Vue.set(state.form, 'sectorsLoading', false);
  },

  [types.GET_INDUSTRIES_OK](state, data) {
    const options = data.map(item => ({
      value: item.code,
      text: item.name
    }));
    Vue.set(state, 'industries', options);
    Vue.set(state.form, 'industriesLoading', false);
  },
};

export default {
  namespaced: true,
  state: initalState,
  getters,
  actions,
  mutations,
};